<template>
    <div class="product-info-container">
        <ul class="product-info-header">
            <li
                v-for="(item, index) in nav"
                :key="index"
                :class="['nav-list', item.value === navSelected ? 'nav-selected' : '']"
                @click="navScoll(index)"
            >{{ item.text }}</li>
        </ul>
        <slot name="content"></slot>
    </div>
</template>

<script>
import {productIntroTabSource} from '../pages/data/global';

export default {
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            nav: productIntroTabSource[this.type],
            navSelected: ''
        };
    },
    mounted() {
        let childs = document.getElementsByClassName('product-info-content')[0].children;
        this.nav.forEach((item, index) => {
            item.top = childs[index].offsetTop + 80;
        });
    },
    methods: {
        // 滚动到指定位置
        navScoll(index) {
            window.scrollTo({
                top: this.nav[index].top,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style lang="less">
li {
    list-style-type: none;
}
.product-info-container {
    width: 930px;
    background: #ffffff;
    .product-info-header {
        height: 46px;
        background: #ffffff;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: flex-start;
        padding: 0;
        .nav-list {
            width: 116px;
            height: 46px;
            background: #ffffff;
            line-height: 46px;
            text-align: center;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #191c3d;
            opacity: 0.8;
            cursor: pointer;

            &:hover {
                border-bottom: 3px solid #2468f2;
            }
        }
        .nav-selected {
            border-bottom: 3px solid #2468f2;
        }
    }
    .product-info-content > div:nth-child(odd) {
        background: #f3f8ff;
    }
    .info-item-content {
        padding-top: 24px;
        padding-bottom: 1px;
        h2 {
            height: 83px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 36px;
            color: #191c3d;
            text-align: center;
            background-size: auto 100%;
            background-position: center;
            background-repeat: no-repeat;
            padding-top: 36px;
        }
        h2:after {
            content: '';
            display: block;
            width: 32px;
            height: 3px;
            border-radius: 3px;
            background-color: #2468f2;
            margin: 0 auto;
        }
    }
    .intro-title {
        background-image: url(../assets/ipc_title_bac.png);
    }
    .content-title {
        background-image: url(../assets/content_title_bac.png);
    }
    .advantage-title {
        background-image: url(../assets/advantage_title_bac.png);
    }
    .process-title {
        background-image: url(../assets/process_title_bac.png);
    }
    .materials-title {
        background-image: url(../assets/materials_title_bac.png);
    }
    .problem-title {
        background-image: url(../assets/problem_title_bac.png);
    }
}
.problem-content {
    padding-top: 21px;
    position: relative;
    .problem-icon {
        width: 158px;
        height: 155px;
        position: absolute;
        right: 34px;
        bottom: 65px;
    }
    .problem-item-content {
        width: 820px;
        margin: 27px auto 33px;
        padding-left: 30px;
        h4 {
            height: 22px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 22px;
            color: #191c3d;
            position: relative;
        }
        h4:before {
            content: '';
            background: url(../assets/question.png) no-repeat;
            background-size: 100% 100%;
            width: 20px;
            height: 20px;
            display: block;
            position: absolute;
            left: -26px;
            top: 0;
        }
        p {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #191c3d;
            opacity: 0.7;
            margin: 8px 0 20px;
            a {
                color: #2468f2;
                text-decoration: none;
            }
            span {
                display: block;
            }
        }
    }
}
</style>
